import { CustomPicture, CustomSource } from "~/components/ui/CustomPicture"
import type { ImageWidget } from "~/types/widgets"

interface ImageProps {
  /**
   * @title Imagem desktop
   */
  desktop: ImageWidget
  /**
   * @title Altura da imagem desktop (apenas número)
   */
  /**
   * @description Se não for passada altura da imagem desktop, será renderizada a altura default (234)
   */
  heightDesktop?: number
  /**
   * @title Imagem mobile
   */
  mobile: ImageWidget
  /**
   * @title Altura da imagem mobile (apenas número)
   */
  /**
   * @description Se não for passada altura da imagem mobile, será renderizada a altura default (292)
   */
  heightMobile?: number
  alt: string
}

export interface Props {
  /**
   * @title Título
   */
  title?: string
  /**
   * @title Subtítulo
   */
  subtitle?: string
  /**
   * @title Imagens
   */
  image: ImageProps
}

export default function GlossaryBanner({ title, subtitle, image }: Props) {
  return (
    <div className='flex items-center m-4 mb-0 lg:m-5 lg:mb-0 min-[1810px]:mx-0 relative'>
      <CustomPicture preload className='w-full h-full max-w-[1800px] mx-auto'>
        <CustomSource
          media='(max-width: 1023px)'
          src={image.mobile}
          width={768}
          height={image.heightMobile ?? 292}
          fetchPriority='high'
          factors={[0.5, 1]}
        />
        <CustomSource
          media='(min-width: 1024px)'
          src={image.desktop}
          width={1800}
          height={image.heightDesktop ?? 234}
          fetchPriority='high'
          factors={[0.5, 0.75, 1]}
        />
        <img
          loading='eager'
          src={image.desktop}
          alt={image.alt}
          className='w-full h-full object-cover'
        />
      </CustomPicture>

      {(!!title || !!subtitle) && (
        <div className='lg:max-w-lg xl:max-w-96 mx-5 lg:mx-32 absolute flex flex-col gap-1'>
          {!!title && <h1 className='text-2xl text-[#FF8A3D]'>{title}</h1>}
          {!!subtitle && <p className='text-sm text-white'>{subtitle}</p>}
        </div>
      )}
    </div>
  )
}
